const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.contact': 'Contact',
  'nav.cta': 'Get Consultation',
  'nav.tagline': 'Relocation & Business Support',

  // Hero Section
  'hero.badge': 'For Chinese Citizens in Armenia',
  'hero.title1': 'Move to Armenia.',
  'hero.title2': 'Register Your Business.',
  'hero.title3': 'We Handle the Process.',
  'hero.desc1': 'For Chinese citizens who want a smooth relocation, a properly registered company, and the right legal and accounting support — without navigating an unfamiliar system alone.',
  'hero.desc2': 'We are a local team based in Yerevan. We speak your language, know the local rules, and coordinate everything from housing and permits to business registration and bookkeeping.',
  'hero.ctaPrimary': 'Get a Free Consultation',
  'hero.ctaSecondary': 'See Our Services',
  'hero.trust1': 'Local team in Yerevan',
  'hero.trust2': 'Chinese, Russian & English',
  'hero.trust3': 'Housing · Business · Legal · Permits',
  'hero.trust4': 'Long-term partnership',

  // Trust Bar
  'trust.t1.title': 'Based in Yerevan',
  'trust.t1.desc': 'A real local office, not a remote advisory service',
  'trust.t2.title': 'Chinese-Speaking Team',
  'trust.t2.desc': 'Full communication in Chinese, Russian, and English',
  'trust.t3.title': 'Everything in One Place',
  'trust.t3.desc': 'Housing, business, legal, permits — one team handles it all',
  'trust.t4.title': 'From Arrival to Ongoing',
  'trust.t4.desc': 'We support you at every stage, not just the first step',

  // About Section
  'about.badge': 'About Us',
  'about.title': 'We Are a Local Team in Yerevan.\nNot a Remote Consultancy.',
  'about.desc1': 'We help Chinese citizens relocate to Armenia, open a business, find housing or an office, and get proper legal, accounting, and immigration support. Everything is managed by our in-house team in Yerevan — not outsourced, not remote.',
  'about.desc2': 'What makes us different is not the list of services we offer, but how we deliver them: as a single coordinated team that speaks your language, understands your priorities, and stays with you long after the initial paperwork is done.',
  'about.point1': 'In-house team in Yerevan — we know the local market, laws, and contacts firsthand',
  'about.point2': 'Chinese, Russian, and English — full communication in your preferred language',
  'about.point3': 'No handoffs, no gaps — housing, legal, business, and permits coordinated by one team',
  'about.point4': 'We stay engaged after setup — ongoing accounting, legal, and practical support',
  'about.floatLabel': 'Yerevan, Armenia',
  'about.floatDesc': 'Local team on the ground — not a remote service',
  'about.whoTitle': 'Who We Work With',
  'about.whoSubtitle': 'Chinese Clients at Every Stage of Relocation',
  'about.client1.title': 'Private Individuals',
  'about.client1.desc': 'People moving to Armenia for lifestyle, safety, family reasons, or a fresh start. We manage housing, residence permits, and the practical side of settling in.',
  'about.client2.title': 'Entrepreneurs',
  'about.client2.desc': 'Business owners who want to register a company in Armenia, find an office, and have proper legal and accounting infrastructure from day one.',
  'about.client3.title': 'Companies & Investors',
  'about.client3.desc': 'Organizations looking for a reliable local partner to manage compliance, expand operations, or explore Armenia\'s business environment firsthand.',

  // Services Preview
  'servicesPreview.badge': 'What We Do',
  'servicesPreview.title': 'Services We Provide',
  'servicesPreview.desc': 'All services are delivered by our in-house team in Yerevan — coordinated as one process when needed, or individually for a single task.',
  'servicesPreview.seeDetails': 'See Details',
  'servicesPreview.viewAll': 'View All Services',
  'servicesPreview.s1.title': 'Housing Search',
  'servicesPreview.s1.desc': 'We find apartments and houses in Yerevan based on your budget, preferred location, and timeline — and handle negotiations and lease review on your behalf.',
  'servicesPreview.s2.title': 'Office Search',
  'servicesPreview.s2.desc': 'From coworking desks to private offices and serviced spaces — we identify options, coordinate viewings, and support the lease process.',
  'servicesPreview.s3.title': 'Business Registration',
  'servicesPreview.s3.desc': 'We manage the full company registration process in Armenia: legal form selection, document preparation, tax registration, and post-registration setup.',
  'servicesPreview.s4.title': 'Legal & Accounting Support',
  'servicesPreview.s4.desc': 'Ongoing legal advice and professional bookkeeping to keep your business compliant — handled by our in-house team, not subcontractors.',
  'servicesPreview.s5.title': 'Residence Permit',
  'servicesPreview.s5.desc': 'We assess your situation, prepare the correct documentation, and coordinate with migration authorities to obtain or renew your residence status in Armenia.',
  'servicesPreview.s6.title': 'Ongoing Local Support',
  'servicesPreview.s6.desc': 'After setup, we remain your point of contact for questions, renewals, legal changes, and any practical matters that arise while living or operating in Armenia.',

  // Why Armenia
  'whyArmenia.badge': 'Why Armenia',
  'whyArmenia.title': 'Why Chinese Citizens and Entrepreneurs Are Choosing Armenia',
  'whyArmenia.desc1': 'Armenia is not a compromise destination — it is a practical choice for those who want an accessible business environment, a genuine quality of life, and a real path to legal residency.',
  'whyArmenia.desc2': 'The combination of low business registration costs, a transparent legal framework, and a welcoming attitude toward foreign nationals makes it one of the more underrated options for Chinese citizens building an international presence.',
  'whyArmenia.cta': 'Ask Us About Armenia',
  'whyArmenia.r1.title': 'Simple Company Registration',
  'whyArmenia.r1.desc': 'A company in Armenia can be registered within a few business days. The process is straightforward, fully documented, and does not require physical presence throughout.',
  'whyArmenia.r2.title': 'Competitive Tax Environment',
  'whyArmenia.r2.desc': 'Armenia offers a transparent and relatively low-tax business environment with clear rules for foreign-owned companies, individual entrepreneurs, and IT sector operators.',
  'whyArmenia.r3.title': 'Strategic Location',
  'whyArmenia.r3.desc': 'Positioned at the crossroads of Europe, Russia, and the Middle East, Armenia serves as a practical base for businesses with interests across multiple regions.',
  'whyArmenia.r4.title': 'Growing Chinese Community',
  'whyArmenia.r4.desc': 'Yerevan has an established and growing Chinese business community. Chinese restaurants, suppliers, and professional networks are already in place.',
  'whyArmenia.r5.title': 'Accessible Cost of Living',
  'whyArmenia.r5.desc': 'Compared to major Asian or European hubs, the cost of housing, office space, and everyday expenses in Yerevan is practical for individuals and businesses at various scales.',
  'whyArmenia.r6.title': 'Stable and Welcoming Environment',
  'whyArmenia.r6.desc': 'Armenia maintains a welcoming approach to foreign residents and entrepreneurs. Chinese citizens can reside and operate businesses with relatively few bureaucratic obstacles.',

  // Why Us
  'whyUs.badge': 'Why Work With Us',
  'whyUs.title': 'Why Clients Choose Us\nOver Individual Specialists',
  'whyUs.desc': 'Working with us means you deal with one trusted team instead of juggling multiple vendors who do not communicate with each other. That single difference saves time, reduces mistakes, and makes the whole process far less stressful.',
  'whyUs.r1.title': 'One Process, Not Six Separate Vendors',
  'whyUs.r1.desc': 'Most people end up managing a lawyer, a real estate agent, an accountant, and a visa agent separately. We coordinate all of it — which means faster results, fewer gaps, and no conflicting advice.',
  'whyUs.r2.title': 'We Know Armenia From the Inside',
  'whyUs.r2.desc': 'Our team lives and works in Yerevan. We know which neighborhoods suit which lifestyles, which banks open accounts for Chinese nationals quickly, and how to navigate local bureaucracy without delays.',
  'whyUs.r3.title': 'No Language Barrier',
  'whyUs.r3.desc': 'All consultations, documents, and ongoing communication can be handled in Chinese. We also work in Russian and English, so nothing gets lost in translation.',
  'whyUs.r4.title': 'Legal Accuracy, Not Just Speed',
  'whyUs.r4.desc': 'We do not cut corners on legal compliance. Your company registration, residence permit, and accounting are handled correctly from the start — avoiding problems later.',
  'whyUs.r5.title': 'We Stay With You After Setup',
  'whyUs.r5.desc': 'After your company is registered and your apartment is signed, questions keep coming. We remain your point of contact for legal updates, tax questions, renewals, and anything that arises.',

  // How We Work
  'howWeWork.badge': 'Our Process',
  'howWeWork.title': 'How We Work With You',
  'howWeWork.desc': 'A consistent process that avoids surprises and keeps you in control at every stage.',
  'howWeWork.s1.number': '01',
  'howWeWork.s1.title': 'Initial Consultation',
  'howWeWork.s1.desc': 'We start with a free conversation to understand your situation, goals, and timeline. You leave with a clear picture of what is involved and what comes next.',
  'howWeWork.s2.number': '02',
  'howWeWork.s2.title': 'Personalised Action Plan',
  'howWeWork.s2.desc': 'We prepare a specific plan for your case — which services you need, in what order, what documents to gather, and what realistic timelines look like.',
  'howWeWork.s3.number': '03',
  'howWeWork.s3.title': 'Execution and Coordination',
  'howWeWork.s3.desc': 'We handle the work — finding housing, registering your company, preparing permit documents, coordinating with lawyers, accountants, and authorities.',
  'howWeWork.s4.number': '04',
  'howWeWork.s4.title': 'Ongoing Support',
  'howWeWork.s4.desc': 'Once the initial setup is complete, we remain available as your local partner — for accounting, renewals, legal questions, or any new needs that come up.',

  // FAQ
  'faq.badge': 'FAQ',
  'faq.title': 'Common Questions',
  'faq.desc': 'Practical answers to what our clients ask most often.',
  'faq.q1': 'Can I start working with you before I arrive in Armenia?',
  'faq.a1': 'Yes — and most of our clients do. We handle the entire pre-arrival process remotely: initial consultation, company registration, housing shortlist, bank account preparation, and residence permit documents can all be started before you land. You arrive to a situation that is already largely prepared.',
  'faq.q2': 'How long does the full relocation and business setup process take?',
  'faq.a2': 'Company registration in Armenia typically takes 3 to 7 business days. Finding and securing housing depends on your requirements and availability, but most clients are settled within 2 to 4 weeks. Residence permits vary by type but usually take several weeks to process. We give you a realistic timeline at the start and keep you updated throughout.',
  'faq.q3': 'Can you help with opening a bank account in Armenia?',
  'faq.a3': 'Yes. We guide you through the banking process, including which banks are most accessible for Chinese nationals, what documentation is required, and how to prepare. We accompany you to the appointment or provide clear preparation materials depending on your situation.',
  'faq.q4': 'What documents do I need to prepare before we start?',
  'faq.a4': 'It depends on what you need — business registration, housing, or a residence permit each have different requirements. At the start of our engagement, we provide you with a clear, personalised document checklist so there are no surprises. We also help you prepare and certify documents as needed.',
  'faq.q5': 'Do you provide support in Chinese?',
  'faq.a5': 'Yes. Our team communicates fluently in Chinese throughout the entire process — consultations, document explanations, status updates, and follow-up questions. We also work in Russian and English if preferred.',
  'faq.q6': 'Can I use several services at the same time?',
  'faq.a6': 'Yes, and it is usually the most efficient approach. Many clients register their company, look for an office, and begin the residence permit process in parallel. We coordinate the timelines so these workstreams do not conflict — and often accelerate each other.',
  'faq.q7': 'What happens after the initial setup is complete?',
  'faq.a7': 'We do not hand you off and disappear. Many clients continue working with us for ongoing accounting, legal support, permit renewals, and general questions about operating in Armenia. We are a long-term partner, not a one-time service.',
  'faq.q8': 'I am still evaluating whether to move to Armenia. Can I contact you?',
  'faq.a8': 'Absolutely — and this is one of the most common first steps. We can give you a realistic overview of what relocation and business setup actually involves in terms of costs, timelines, and requirements. There is no commitment and no pressure. Many of our long-term clients started with a single exploratory conversation.',

  // Final CTA
  'finalCta.badge': 'Ready to Start?',
  'finalCta.title': "Tell Us What You Need.\nWe Will Tell You What's Possible.",
  'finalCta.desc': 'Whether you are still exploring or ready to begin — reach out and we will give you a clear, honest overview of your options. No obligation, no vague promises.',
  'finalCta.primary': 'Send Us a Request',
  'finalCta.secondary': 'View Services',

  // Footer
  'footer.tagline': 'A local team in Yerevan helping Chinese citizens relocate, register a business, and stay legally in Armenia. Housing, legal, accounting, and residence permits — all under one roof.',
  'footer.services': 'Services',
  'footer.navigation': 'Navigation',
  'footer.contact': 'Contact',
  'footer.location': 'Yerevan, Armenia',
  'footer.copyright': 'All rights reserved.',
  'footer.motto': 'Relocation & Business Support for Chinese Citizens in Armenia',
  'footer.s1': 'Housing Search',
  'footer.s2': 'Office Search',
  'footer.s3': 'Business Registration',
  'footer.s4': 'Legal Support',
  'footer.s5': 'Accounting Support',
  'footer.s6': 'Residence Permit',
  'footer.email': 'Email',
  'footer.telegram': 'Telegram',

  // Services Page
  'servicesPage.heroNav': 'Home',
  'servicesPage.heroNavCurrent': 'Services',
  'servicesPage.heroTitle': 'Services for Chinese\nCitizens in Armenia',
  'servicesPage.heroDesc': 'Practical support for relocation, business setup, and legal stay in Armenia — from housing and office search to company registration, legal, accounting, and residence permits.',
  'servicesPage.ctaTitle': 'Need One Service or Full Support?',
  'servicesPage.ctaDesc': 'Tell us about your situation and we will recommend the right approach — whether that is a single service or a complete relocation package.',
  'servicesPage.ctaBtn': 'Discuss Your Request',

  // Services List
  'sl.s1.title': 'Housing Search in Armenia',
  'sl.s1.desc': 'Finding the right apartment or house is often the first practical step when relocating. Yerevan\'s rental market moves quickly, and navigating it without local contacts is time-consuming. We do the search, filter, and coordination for you.',
  'sl.s1.d1': 'Detailed brief — understanding your requirements, budget, and preferred areas',
  'sl.s1.d2': 'Curated shortlist of available properties matching your criteria',
  'sl.s1.d3': 'Organising viewings and translating landlord communication',
  'sl.s1.d4': 'Lease negotiation and review before you sign',
  'sl.s1.d5': 'Assistance with utility setup and move-in practicalities',
  'sl.s1.cta': 'Ask About Housing Options',
  'sl.s2.title': 'Office Search for Business',
  'sl.s2.desc': 'Whether you need a business address for registration purposes, a private office, or a coworking setup, we identify suitable options and manage the process from search to signed agreement.',
  'sl.s2.d1': 'Understanding your workspace requirements and timeline',
  'sl.s2.d2': 'Sourcing private offices, serviced spaces, and coworking options',
  'sl.s2.d3': 'Coordinating viewings and handling negotiations',
  'sl.s2.d4': 'Lease review and signing support',
  'sl.s2.d5': 'Legal address registration for company purposes if needed',
  'sl.s2.cta': 'Explore Office Options',
  'sl.s3.title': 'Business Registration in Armenia',
  'sl.s3.desc': 'Armenia has a straightforward registration process with low setup costs and relatively favorable tax conditions for foreign-owned businesses. We manage everything — from choosing the right legal structure to receiving your registration documents.',
  'sl.s3.d1': 'Choosing the right legal entity based on your business model and goals',
  'sl.s3.d2': 'Preparing and submitting all registration documents',
  'sl.s3.d3': 'Tax registration and taxpayer ID assignment',
  'sl.s3.d4': 'Guidance on opening a business bank account',
  'sl.s3.d5': 'Post-registration briefing on obligations, reporting, and next steps',
  'sl.s3.cta': 'Start Your Registration',
  'sl.s4.title': 'Legal Support',
  'sl.s4.desc': 'Operating in a new legal environment always raises questions — about contracts, employment, corporate structure, or compliance. Our legal team provides practical guidance rooted in current Armenian law, not generic advice.',
  'sl.s4.d1': 'Contract drafting and review in Armenian, Russian, or English',
  'sl.s4.d2': 'Corporate structure and shareholder agreement advice',
  'sl.s4.d3': 'Employment law guidance and local labour compliance',
  'sl.s4.d4': 'IP registration and basic protection guidance',
  'sl.s4.d5': 'Representation and coordination with local authorities when required',
  'sl.s4.cta': 'Ask a Legal Question',
  'sl.s5.title': 'Accounting Support',
  'sl.s5.desc': 'Every registered company in Armenia has ongoing tax and reporting obligations. Our accounting team handles your bookkeeping, declarations, and payroll so you stay compliant without spending your own time on it.',
  'sl.s5.d1': 'Monthly bookkeeping and financial statement preparation',
  'sl.s5.d2': 'Tax declarations and submissions to Armenian authorities',
  'sl.s5.d3': 'Payroll processing and employee tax handling',
  'sl.s5.d4': 'VAT registration and regular filing',
  'sl.s5.d5': 'Tax optimisation advice within the legal framework',
  'sl.s5.cta': 'Get Accounting Support',
  'sl.s6.title': 'Legalization & Residence Permit',
  'sl.s6.desc': 'Obtaining and maintaining legal residency in Armenia involves specific documentation, deadlines, and interactions with migration authorities. We assess your situation, prepare everything correctly, and track the process through to completion.',
  'sl.s6.d1': 'Assessment of the most suitable residence permit type for your situation',
  'sl.s6.d2': 'Full document preparation and translation where required',
  'sl.s6.d3': 'Submission and coordination with Armenian migration service',
  'sl.s6.d4': 'Status monitoring and proactive renewal reminders',
  'sl.s6.d5': 'Entry advisory for Chinese nationals arriving for the first time',
  'sl.s6.cta': 'Check Your Eligibility',

  // Work Formats
  'wf.badge': 'How We Work',
  'wf.title': 'Choose the Right Level of Support',
  'wf.desc': 'Whether you need a single question answered or a complete relocation managed — we have a format that fits.',
  'wf.popular': 'Most Popular',
  'wf.f1.title': 'One-Time Consultation',
  'wf.f1.subtitle': 'For early-stage clarity',
  'wf.f1.desc': 'A focused conversation to help you understand your options, assess what is involved, and decide whether — and how — to proceed. No commitment required.',
  'wf.f1.feat1': 'Up to 60 minutes, conducted remotely or in person',
  'wf.f1.feat2': 'Honest answers to your specific questions',
  'wf.f1.feat3': 'Overview of timelines, costs, and requirements',
  'wf.f1.feat4': 'Written summary and recommended next steps',
  'wf.f1.cta': 'Book a Consultation',
  'wf.f2.title': 'Single-Service Support',
  'wf.f2.subtitle': 'For one defined task',
  'wf.f2.desc': 'Full end-to-end support for a single service — housing search, company registration, residence permit, or another specific task — with a clear scope and timeline.',
  'wf.f2.feat1': 'Complete handling of one defined service',
  'wf.f2.feat2': 'All documents, coordination, and communication included',
  'wf.f2.feat3': 'Regular progress updates throughout',
  'wf.f2.feat4': 'Brief advisory after completion if questions arise',
  'wf.f2.cta': 'Discuss a Service',
  'wf.f3.title': 'Comprehensive Support',
  'wf.f3.subtitle': 'For full relocation & business setup',
  'wf.f3.desc': 'Our most complete engagement. We coordinate your entire relocation and business setup — housing, office, company registration, legal, accounting, and permits — as one unified process.',
  'wf.f3.feat1': 'All relevant services included in one engagement',
  'wf.f3.feat2': 'Single point of contact throughout the entire process',
  'wf.f3.feat3': 'Coordinated timelines across housing, legal, and business',
  'wf.f3.feat4': 'Priority communication and long-term ongoing support',
  'wf.f3.cta': 'Discuss Full Support',

  // Contact Page
  'contact.heroNav': 'Home',
  'contact.heroNavCurrent': 'Contact',
  'contact.heroTitle': "Let's Talk",
  'contact.heroDesc': 'Tell us briefly what you need — relocation, housing, business registration, legal or accounting support, or a residence permit. We will respond with a clear and honest overview of your options.',
  'contact.reachTitle': 'Reach Us Directly',
  'contact.reachDesc': 'Use whichever channel is most convenient for you. We communicate in Chinese, Russian, and English, and respond within one business day.',
  'contact.officeTitle': 'Our Office',
  'contact.officeLocation': 'Yerevan, Republic of Armenia',
  'contact.officeNote': 'In-person meetings available by appointment',
  'contact.responseNote': 'We respond to all inquiries within one business day. For faster communication, WhatsApp and Telegram are the quickest channels.',
  'contact.formTitle': 'Send a Request',
  'contact.formDesc': 'Tell us what you need and we will reply with a clear overview of how we can help and what the process looks like.',
  'contact.successTitle': 'Request Received',
  'contact.successDesc': 'Thank you for reaching out. We will review your request and reply within one business day.',
  'contact.labelName': 'Full Name',
  'contact.labelContact': 'Phone / WhatsApp / WeChat',
  'contact.labelEmail': 'Email',
  'contact.labelService': 'What Do You Need Help With?',
  'contact.labelComment': 'Your Situation or Question',
  'contact.placeholderName': 'Your full name',
  'contact.placeholderContact': 'Your preferred contact number or handle',
  'contact.placeholderEmail': 'your@email.com',
  'contact.placeholderService': 'Select the most relevant option',
  'contact.placeholderComment': 'Briefly describe your situation, timeline, or specific question. The more context you share, the more useful our reply will be.',
  'contact.errorMsg': 'Something went wrong. Please try again or contact us directly via email.',
  'contact.btnSend': 'Send Request',
  'contact.btnSending': 'Sending...',
  'contact.privacy': 'By submitting this form, you agree to be contacted by our team in response to your inquiry.',
  'contact.maxLength': 'Maximum 500 characters.',
  'contact.opt1': 'Housing Search',
  'contact.opt2': 'Office Search',
  'contact.opt3': 'Business Registration',
  'contact.opt4': 'Legal Support',
  'contact.opt5': 'Accounting Support',
  'contact.opt6': 'Legalization & Residence Permit',
  'contact.opt7': 'Comprehensive Support',
  'contact.opt8': 'Initial Consultation — I Have Questions',

  // Language switcher
  'lang.en': 'EN',
  'lang.zh': '中文',

  // SEO — Home
  'seo.home.title': 'ArmeniaSettle — Relocation & Business Support for Chinese Citizens in Armenia',
  'seo.home.description': 'We help Chinese citizens relocate to Armenia and set up their business — housing search, office search, company registration, legal and accounting support, and residence permit assistance. Local team in Yerevan.',

  // SEO — Services
  'seo.services.title': 'Services — Housing, Business Registration & Legal Support in Armenia | ArmeniaSettle',
  'seo.services.description': 'Practical services for Chinese citizens in Armenia: housing search, office search, business registration, legal and accounting support, and residence permit assistance. One team, full coverage.',

  // SEO — Contact
  'seo.contact.title': 'Contact Us — ArmeniaSettle | Yerevan, Armenia',
  'seo.contact.description': 'Reach ArmeniaSettle via Telegram or email. We respond within one business day and communicate in Chinese, Russian, and English. In-person meetings available by appointment in Yerevan.',
};

export default common;
